export default __webpack_public_path__ + "static/media/Gurantee.dc176e69.svg";